__turbopack_context__.v({
  "footnote": "portal-module__2iFjNW__footnote",
  "header": "portal-module__2iFjNW__header",
  "headerText": "portal-module__2iFjNW__headerText",
  "inner": "portal-module__2iFjNW__inner",
  "regionCard": "portal-module__2iFjNW__regionCard",
  "regionUrl": "portal-module__2iFjNW__regionUrl",
  "regions": "portal-module__2iFjNW__regions",
  "root": "portal-module__2iFjNW__root",
});
